import { Icon } from '#/components/Icon/Icon';
import type { IconName } from '#/components/Icon/IconName';
import { getStaticImageSrc } from '#/utils/getImageSrc';

export type LayoutHeaderPanelIcon =
  // mono, inherits the row colour
  | { kind: 'icon'; name: IconName }
  // Resources children reuse the desktop dropdown illustrations
  | { kind: 'image'; src: string }
  // Extras and Log Out: empty slot so labels stay aligned (mainly for ES/PT)
  | { kind: 'none' };

type Props = {
  icon: LayoutHeaderPanelIcon;
};

export function LayoutHeaderPanelRowIcon({ icon }: Props) {
  switch (icon.kind) {
    case 'icon':
      return <Icon name={icon.name} size={20} />;
    case 'image':
      return <img src={getStaticImageSrc(icon.src)} alt="" loading="lazy" />;
    case 'none':
      return null;
  }
}
